var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#616161",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00008 15.5858L15.293 6.29285L16.7072 7.70707L6.70718 17.7071C6.51965 17.8946 6.26529 18 6.00008 18C5.73486 18 5.4805 17.8946 5.29297 17.7071L1.29297 13.7071L2.70718 12.2929L6.00008 15.5858Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0003 15.586L21.2928 6.29297L22.7071 7.70715L12.7075 17.7072C12.3171 18.0977 11.684 18.0977 11.2934 17.7073L9.79297 16.2073L11.207 14.7929L12.0003 15.586Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/double-check.a90ee43034e8f26cd3fd35f6bc98978f.svg";
export { ForwardRef as ReactComponent };